import { Box, Grid, Typography, Paper } from "@mui/material";
import { Icon } from "@iconify/react";

const items = [
  { label: "Food court", icon: "ph:storefront-bold" },
  { label: "Cafe", icon: "ph:coffee-bold" },
  { label: "Cloud kitchen", icon: "ph:cloud-bold" },
  { label: "Ice cream & desserts", icon: "ph:ice-cream-bold" },
  { label: "Bar & brewery", icon: "ph:beer-stein-bold" },

  { label: "Bakery", icon: "ph:cake-bold" },
  { label: "Fine dine", icon: "ph:bowl-food-bold" },
  { label: "QSR", icon: "ph:hamburger-bold" },
  { label: "Pizzeria", icon: "ph:pizza-bold" },
  { label: "Large chain", icon: "ph:storefront-duotone" },
];

export default function BusinessOutletTypes() {
  return (
    <Box
      sx={{
        bgcolor: "#ed5727",
        py: 10,
        textAlign: "center",
        color: "white",
      }}
    >
      {/* Heading */}
      <Typography variant="overline" sx={{ opacity: 0.8 }}>
        OUTLET TYPES
      </Typography>

      <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
        Built for all types of food business
      </Typography>

      <Typography sx={{ mt: 1, opacity: 0.8 }}>
        The complete POS system for every food format & business size
      </Typography>

      {/* Grid */}
      <Grid
        container
        spacing={0}
        sx={{
          width: "100%",
          maxWidth: "1100px",
          mx: "auto",
          mt: 6,
        }}
      >
        {items.map((item) => (
          <Grid
            key={item.label}
            item
            xs={6}
            sm={4}
            md={2.4} // keeps exactly 5 per row
            lg={2.4}
            xl={2.4}
            sx={{
              cursor: "pointer",
              transition: "all 0.25s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.08)",
                borderColor: "#d0d7e2",
              },
            }}
          >
            <Paper
              elevation={0}
              sx={{
                height: 180,
                bgcolor: "rgba(255, 255, 255, 0.05)",
                borderRadius: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <Icon icon={item.icon} width="48" height="48" color="white" />

              <Typography sx={{ mt: 2, fontSize: 14, color: "white" }}>
                {item.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
